import { useQuery } from "@tanstack/react-query"
import { API } from "config"

const useStock = (page = 1, term = null) => useQuery({ queryKey: ['stock', page, term], queryFn: async () => {
    const callback = await API.get(`/stock?page=${page}${term ? `&term=${term}` : ''}`)
    return callback?.data
}, staleTime: 1000 * 60})

export default useStock